<template lang="html">
  <div class="view-nav-template patrimonial-landscape white-box row">
    <div class="menu column">
      <div class="title">
        <span class="icon-eye"></span>
        Paysage Patrimonial
      </div>
      <ul class="ctn-menu column">
        <li class="item-main" :id="typeof menu[key].slug !== 'undefined' ? 'menu-link-' + menu[key].slug : ''" v-for="(item, key) in menu" v-bind:key="key" :class="{active: isActiveFirst(key)}">
          <div class="label" v-html="resolveLabel(item, key)" @click="setActiveFirst(key)"></div>
          <ul class="ctn-second" v-if="item.children && isActiveFirst(key)">
            <li class="item-second" v-for="(child, keyt) in item.children" v-bind:key="keyt" :class="{active: isActiveSecond(keyt)}" @click="setActiveSecond(keyt)">
							<div class="label" v-html="resolveLabel(child, key, keyt)"></div>
						</li>
          </ul>
        </li>
      </ul>
      <div class="btn btn-red" id="saveBtn" @click="save" v-if="activeFirstLevel < 6">
        Sauvegarder
      </div>
    </div>
    <div class="view column" :id="typeof menu[this.activeFirstLevel].slug !== 'undefined' ? 'menu-view-' + menu[this.activeFirstLevel].slug : ''" >
      <div class="title" v-html="menu[activeFirstLevel].label"></div>
      <div class="ctn-component">
        <div class="title-component" v-html="menu[activeFirstLevel].children[activeSecondLevel].label" v-if="menu[activeFirstLevel].children"></div>
        <component v-if="drawComponent" :is="currentComponent" ref="currentComp" @fileupload="addDocument" :user="user"/>
      </div>
      <div class="step row" id="step-change-buttons">
        <div class="btn btn-gold" @click="previousStep">
          Précédent
        </div>
        <div class="btn btn-gold" @click="nextStep" v-if="activeFirstLevel < 6">
          Suivant
        </div>
        <template v-else>
          <button class="btn btn-red" id="downloadEstateBtn" :class="{'btn-disabled': !signatureBtnAvailable || showAnonymousCtaModal}" @click="downloadEstate" v-if="isAnonymous">
            <span class="icon-button-download"></span> Télécharger mon Paysage Patrimonial
          </button>
          <div class="btn btn-red" id="signBtn" :class="{'btn-disabled': !signatureBtnAvailable}" @click="sign" v-else>
            <template v-if="isAdvisor">Demande de signature électronique</template>
            <template v-else>Signer</template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import bus from '@/common/services/Bus'
import emma from '@/common/services/Emma'
import good from '@/common/assets/img/good.svg'
import YourInformations from '@/common/components/MyPatrimonialLandscape/YourInformations'
import YourHome from '@/common/components/MyPatrimonialLandscape/YourHome'
import AnnualRecipe from '@/common/components/MyPatrimonialLandscape/AnnualRecipe'
import RealEstate from '@/common/components/MyPatrimonialLandscape/RealEstate'
import Savings from '@/common/components/MyPatrimonialLandscape/Savings'
// import GFR from '@/common/components/MyPatrimonialLandscape/GFR'
import SpendingNoTaxes from '@/common/components/MyPatrimonialLandscape/SpendingNoTaxes'
import Credits from '@/common/components/MyPatrimonialLandscape/Credits'
import Taxes from '@/common/components/MyPatrimonialLandscape/Taxes'
import ISF from '@/common/components/MyPatrimonialLandscape/ISF'
import Retreat from '@/common/components/MyPatrimonialLandscape/Retreat'
import Influence from '@/common/components/MyPatrimonialLandscape/Influence'
import Following from '@/common/components/MyPatrimonialLandscape/Following'
import Knowledge from '@/common/components/MyPatrimonialLandscape/Knowledge'
import Perspective from '@/common/components/MyPatrimonialLandscape/Perspective'
import Profil from '@/common/components/MyPatrimonialLandscape/Profil'
import Signature from '@/common/components/MyPatrimonialLandscape/Signature'
import Esg from '@/common/components/MyPatrimonialLandscape/Esg'
import UniversignResource from '@/common/resources/Universign'
import {mapGetters} from 'vuex'

export default {
	name: 'PatrimonialEstate',
	props: ['user'],
	data () {
		return {
			drawComponent: true,
			signatureBtnAvailable: true,
			showAnonymousCtaModal: false,
			isAdvisor: (process.env.SITE === 'cgpi'),
			menu: [
				{
					label: '<span class="icon-paysage-vous"></span> Vous',
					slug: 'you',
					name: 'YOU',
					children: [
						{ label: 'Vos informations', component: YourInformations, name: 'YOUR_INFORMATIONS' },
						{ label: 'Votre foyer', component: YourHome, name: 'YOUR_HOME' }
					]
				},
				{
					label: '<span class="icon-paysage-rentree"></span> Avoirs & Rentrées',
					slug: 'assets-icome',
					children: [
						{ label: 'Vos revenus annuels', component: AnnualRecipe, name: 'ANNUAL_RECIPE' },
						{ label: 'Immobilier', component: RealEstate, name: 'REAL_ESTATE' },
						{ label: 'Epargne', component: Savings, name: 'SAVINGS' }
						// { label: 'Bien, Meubles & Créances', component: GFR }
					]
				},
				{
					label: '<span class="icon-paysage-sortis"></span> Sorties',
					slug: 'exits',
					children: [
						{ label: 'Dépenses hors impôts', component: SpendingNoTaxes, name: 'SPENDING_NO_TAXES' },
						{ label: 'Crédit(s)', component: Credits, name: 'CREDITS' }
					]
				},
				{
					label: '<span class="icon-paysage-fiscalite"></span> Fiscalité',
					slug: 'fiscal',
					children: [
						{ label: 'Impôt sur le revenu', component: Taxes, name: 'TAXES' },
						{ label: 'IFI (Impôt sur la Fortune Immobilière)', component: ISF, name: 'ISF' }
					]
				},
				{
					label: '<span class="icon-paysage-retraite"></span> Retraite',
					slug: 'retirement',
					children: [
						{ label: 'Vous', component: Retreat, name: 'RETREAT' }
					]
				},
				{
					label: '<span class="icon-paysage-profil"></span> Profil',
					slug: 'profil',
					children: [
						{ label: 'Influences', component: Influence, name: 'INFLUENCE' },
						{ label: 'Suivi', component: Following, name: 'FOLLOWING' },
						{ label: 'Connaissances', component: Knowledge, name: 'KNOWLEDGE' },
						{ label: 'Objectifs d\'investissement', component: Perspective, name: 'PERSPECTIVE' },
						{ label: 'ESG', component: Esg, name: 'ESG' },
						{ label: 'Profil d\'investisseur', component: Profil, name: 'PROFIL' }
					]
				},
				{
					label: '<span class="icon-file-edit"></span> Signature',
					slug: 'signature',
					component: Signature
				}
			],
			activeFirstLevel: 0,
			activeSecondLevel: 0
		}
	},
	mounted () {
		this.$root.$on('signature-confirm-info', (value) => {
			this.signatureBtnAvailable = value
		})

		this.initPatrimonialData().then(() => {
			this.setCurrentMenuFromUrlParam()
			this.changeMenuSignatureLabelForAnonymous()
		})
	},
	methods: {
		initPatrimonialData () {
			return this.$store.dispatch('getPatrimonial', this.estate.idUser)
		},

		setCurrentMenuFromUrlParam () {
			if (typeof this.$route.params.section === 'undefined') {
				return
			}

			let menuIndex = this.menu.findIndex((element) => typeof element.slug !== 'undefined' && element.slug === this.$route.params.section)

			if (!menuIndex || menuIndex < 0) {
				return
			}

			this.setActiveFirst(menuIndex)
		},

		changeMenuSignatureLabelForAnonymous () {
			if (!this.isAnonymous) {
				return
			}

			let index = this.menu.findIndex((elem) => typeof elem.label !== 'undefined' && elem.label.includes('Signature'))
			if (index <= -1) {
				return
			}

			this.menu[index].label = '<span class="icon-file-edit"></span> Valider'
		},

		isActiveFirst (key) {
			return (this.activeFirstLevel === key)
		},

		isActiveSecond (key) {
			return (this.activeSecondLevel === key)
		},

		setActiveFirst (key) {
			this.activeFirstLevel = key

			if (typeof this.$route.query.sub_section === 'undefined') {
				this.activeSecondLevel = 0
			} else {
				const index = this.menu[key].children.findIndex((element) => typeof element.name !== 'undefined' && element.name === this.$route.query.sub_section)
				this.activeSecondLevel = index
			}

			this.updateCurrentUrl()
		},

		setActiveSecond (key) {
			this.activeSecondLevel = key
		},

		check () {
			return this.$refs.currentComp.validate()
		},

		nextStep () {
			this.check().then((result) => {
				if (result) {
					const firstLevel = this.menu[this.activeFirstLevel]
					const secondLevel = (firstLevel.children) ? firstLevel.children[this.activeSecondLevel] : null
					if (secondLevel) {
						if (firstLevel.children.length > this.activeSecondLevel + 1) {
							this.activeSecondLevel = this.activeSecondLevel + 1
						} else {
							if (this.menu.length > this.activeFirstLevel + 1) {
								this.activeFirstLevel = this.activeFirstLevel + 1
								this.activeSecondLevel = 0
							}
						}
					} else {
						this.activeFirstLevel = (this.menu.length > this.activeFirstLevel + 1) ? this.activeFirstLevel + 1 : this.activeFirstLevel
					}

					this.updateCurrentUrl()

					this.save()
				}
			})
		},

		updateCurrentUrl () {
			if (typeof this.menu[this.activeFirstLevel].slug === 'undefined') {
				return
			}

			this.$router.push({ name: 'PatrimonialLandscapeUpdate', params: {section: this.menu[this.activeFirstLevel].slug} })
		},

		previousStep () {
			this.check().then((result) => {
				if (result) {
					const firstLevel = this.menu[this.activeFirstLevel]
					const secondLevel = (firstLevel.children) ? firstLevel.children[this.activeSecondLevel] : null
					if (secondLevel) {
						if (this.activeSecondLevel > 0) {
							this.activeSecondLevel = this.activeSecondLevel - 1
						} else {
							if (this.activeFirstLevel > 0) {
								this.activeFirstLevel = this.activeFirstLevel - 1
								this.activeSecondLevel = (this.menu[this.activeFirstLevel].children) ? this.menu[this.activeFirstLevel].children.length - 1 : 0
							}
						}
					} else {
						this.activeFirstLevel = (this.activeFirstLevel > 0) ? this.activeFirstLevel - 1 : this.activeFirstLevel
						this.activeSecondLevel = (this.menu[this.activeFirstLevel].children) ? this.menu[this.activeFirstLevel].children.length - 1 : 0
					}
					this.updateCurrentUrl()
				}
			})
		},

		isSafari () {
			const isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1
			const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome/') > -1
			return isSafari && !isChrome
		},

		sign () {
			if (!this.signatureBtnAvailable) {
				return
			}

			this.check().then((result) => {
				this.$store.dispatch('savePatrimonial', this.user.id).then(() => {
					this.$store.commit('LOADER_IN')
					emma.get('api/estate/private/doc/' + this.user.id).then((result) => {
						const idFile = result.data.file.split('/')[result.data.file.split('/').length - 1]
						UniversignResource.signPersonalEstate(idFile).then((result) => {
							if (result.data.success) {
								if (process.env.SITE === 'client') {
									const win = window.open(result.data.signatureUrl)
									if (win) {
										win.focus()

										this.$router.push({ name: 'PatrimonialLandscape' })
									} else {
										this.$root.$emit('signature-popup-blocked')
									}
								} else {
									this.$notify({
										type: 'success',
										group: 'default',
										title: 'La demande de signature a bien été envoyée au client',
										text: ''
									})

									this.$router.push({ name: 'PatrimonialLandscape' })
								}
								this.$store.commit('LOADER_OUT')
								// this.$router.push({ name: 'PatrimonialLandscape' })
							} else {
								this.$notify({
									type: 'error',
									group: 'default',
									title: 'Une erreur est survenue',
									text: result.data.error
								})
								this.$store.commit('LOADER_OUT')
							}
						}).catch((error) => {
							console.log(error)
							this.$store.commit('LOADER_OUT')
						})
					}).catch((error) => {
						this.$store.commit('LOADER_OUT')
						console.warn(error)
					})
				})
			}).catch((error) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: error.message,
					text: null
				})
			})
		},

		addDocument (file) {
			this.$store.dispatch('addDocument', {
				user_id: this.user.id,
				category: 'justificatifs',
				type: file.type.replace('application/', ''),
				confidential: false,
				file: file,
				subcategory: null,
				signature_required: false,
				signature_token: null,
				original_name: file.name
			}).then(() => {
				console.log('document added avec success')
			}).catch((error) => {
				console.log('Error from add document : ', error)
			})
		},

		save () {
			this.check().then((result) => {
				if (this.$refs.currentComp.save) {
					this.$refs.currentComp.save().then(() => {
						this.$store.dispatch('savePatrimonial', this.user.id).then(() => {
							this.$notify({
								type: 'success',
								group: 'default',
								title: 'Vos modifications ont bien été enregistrées',
								text: ''
							})
						})
					})
				} else {
					this.$store.dispatch('savePatrimonial', this.user.id).then(() => {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Vos modifications ont bien été enregistrées',
							text: ''
						})
					})
				}
			})
		},

		resolveLabel (comp, primary, secondary = null) {
			let validated = false
			if (secondary !== null) {
				validated = this.$store.getters.isValidated(comp.name)
			} else {
				if (comp.children) {
					let status = true
					comp.children.forEach((child) => {
						if (child.name !== 'PROFIL') {
							if (!this.$store.getters.isValidated(child.name)) {
								status = false
							}
						}
					})
					validated = status
				}
			}
			return (validated) ? comp.label + ' <img src="' + good + '">' : comp.label
		},

		downloadEstate () {
			if (!this.estate || !this.estate.updatedAt) {
				return
			}

			emma.get('api/estate/private/doc/' + this.estate.idUser).then((result) => {
				const win = window.open(process.env.API_ROOT + result.data.file.substring(1, result.data.file.length))
				win.focus()
				this.showAnonymousCtaModal = this.isAnonymous
				if (this.isAnonymous) {
					this.$root.$emit('show-anonymous-cta-modal', this.showAnonymousCtaModal)
					this.$store.dispatch('setForceCompleteProfileAsTrue')
				}
			}).catch((error) => {
				console.warn(error)
			})
		}

	},
	computed: {

		...mapGetters({
			estate: 'estate',
			isAnonymous: 'isAnonymous'
		}),

		currentComponent () {
			if (this.menu[this.activeFirstLevel].children) {
				if (this.activeSecondLevel !== -1) {
					return this.menu[this.activeFirstLevel].children[this.activeSecondLevel].component
				} else {
					return this.menu[this.activeFirstLevel].component
				}
			} else {
				return this.menu[this.activeFirstLevel].component
			}
		}

	}
}
</script>



// WEBPACK FOOTER //
// PatrimonialLandscape.vue?471ae55f